module.exports = __webpack_public_path__ + "static/media/home-process-7.571c313c.svg";